export default {
    'GetAndonRuleFlow': '/api/andon_rule/rule_flow',    /**查询安灯规则流**/
    'GetAndonRuleNotify': '/api/andon_rule_role/list',  /**查询安灯规则通知对象 */
}
